var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UIButton',{on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.$t('bi.footer.partners'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }